<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 26.6667 26.6667"
    fill="none"
  >
    <path
      d="M24.2424 13.3333C24.2424 7.30841 19.3583 2.42424 13.3333 2.42424C7.30841 2.42424 2.42424 7.30841 2.42424 13.3333C2.42424 19.3583 7.30841 24.2424 13.3333 24.2424C19.3583 24.2424 24.2424 19.3583 24.2424 13.3333ZM26.6667 13.3333C26.6667 20.6971 20.6971 26.6667 13.3333 26.6667C5.96954 26.6667 0 20.6971 0 13.3333C0 5.96954 5.96954 0 13.3333 0C20.6971 0 26.6667 5.96954 26.6667 13.3333Z"
      fill="currentColor"
    />
    <path
      d="M12.1212 6.06061C12.1212 5.39117 12.6639 4.84848 13.3333 4.84848C14.0028 4.84848 14.5455 5.39117 14.5455 6.06061V12.584L18.724 14.6733C19.3227 14.9727 19.5655 15.701 19.2661 16.2997C18.9667 16.8985 18.2384 17.1412 17.6397 16.8419L12.7912 14.4176C12.3805 14.2123 12.1212 13.7925 12.1212 13.3333V6.06061Z"
      fill="currentColor"
    />
  </svg>
</template>
